/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages
		'common': {
			init: function() {

				$('.gfield_select').select2();

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
				var html = $('html');

				$('.header--menu').on('click', function() {
					html.removeClass('loading').toggleClass('nav-open');
				});
				
				$('.nav-mobile-primary-close--wrapper').on('click', function() {
						html.removeClass('nav-open');
				});

				$('.hidden-ref').click( function(e){
					e.preventDefault();
					$('.hidden-modal').toggle();
				});

				$('.close-hidden-modal').click(function(){
					$('.hidden-modal').toggle();
				});

				$('.submit-btn').click(function(e){
					e.preventDefault();
					var to = $("input#to_email").val();
					var from = $("input#self_email").val();
					var refer = encodeURIComponent(document.URL);
					var title = $('.single_job_listing').find('h1');
					var dataString = 'to_email='+ to + '&from_email=' + from + '&title=' + title[0].innerHTML + '&refer=' + refer;

					$.ajax({
						type: "POST",
						url: "/process/process.php",
						data: dataString,
						success: function() {
						  //display message back to user here
						  $('.hidden-modal').closest('form').find("input[type=text], textarea").val("");
						  $('.hidden-modal').toggle();
						},
						error: function(XMLHttpRequest, textStatus, errorThrown) { 
							alert("Status: " + textStatus); alert("Error: " + errorThrown); 
						}    
					  });
				});

				$('#submit-job-form').children().each( function(e){
					$(this).find('select').select2({
						width: '100%',
						sortResults: function(data) {
							/* Sort data using lowercase comparison */
							return data.sort(function (a, b) {
								a = a.text.toLowerCase();
								b = b.text.toLowerCase();
								if (a > b) {
									return 1;
								} else if (a < b) {
									return -1;
								}
								return 0;
							});
						}
					});
				});

				// $('#job_industry').select2({
				// 	width: '100%'
				// });
				// $('#job_external_type').select2({
				// 	width: '100%'
				// });
				
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				
				$('.select2-select').select2({
					placeholder: "Select your Industry to find a solution",
					allowClear: true,
					width: '100%',
					minimumResultsForSearch: -1,
					
				});

				$('b[role="presentation"]').hide();
				$('.select2-selection__arrow').append('<i class="fa fa-chevron-down"></i>');

				$('.video-block--video').fitVids();


				$('.select2-select').on('change', function() {
					var a = $('.select2-select').select2('val');
					window.location.href = a ;
				});
			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// About us page, note the change from about-us to about_us.
		'our_solutions': {
			init: function() {
				// JavaScript to be fired on the about us page
				$('.select2-select').select2({
					placeholder: "Select your Industry to find a solution",
					allowClear: true,
					width: '100%',
					minimumResultsForSearch: -1,
					
				});

				$('.select2-select').on('change', function() {
					var a = $('.select2-select').select2('val');
					window.location.href = a ;
				});
				
				$('b[role="presentation"]').hide();
				$('.select2-selection__arrow').append('<i class="fa fa-chevron-down"></i>');
			},
			finalize: function() {
				
			}
		},
		'solutions': {
			init: function() {
				$('.preview_area').on('click', function() {
					$(this).parent('.business-item').children('.container-button').click();
				});

				$('.container-button').on('click', function(i,n) {
					
					
					var x = $(this).parent('.business-item').siblings('.business-item').children('.content_area');
					
					$(x).each( function(i , val) {
						if ( $(val).hasClass('active') ) {
							$(val).removeClass('active');
							$(val).addClass('hidden');
						} 

						});


					var item = $(this).parent('.business-item').children('.content_area');

					if ( $(item).hasClass('active') ) {

						$(item).removeClass('active');
						$(item).addClass('hidden'); 
					
					} else if ( $(item).hasClass('hidden') ) {

						$(item).removeClass('hidden');
						$(item).addClass('active');
						
					}
					
					
				});
			}
		},
		'frequently_asked_questions':{
			init: function() {

				$('.entry-title').on('click', function() {
					
					var a = $(this).parents('article');
					var n = $(a).find('i.fa');

					if( $(a).hasClass('closed') ) {
						
						$(n).removeClass('fa-plus').addClass('fa-minus');
						$(a).removeClass('closed').addClass('opened');
						
					} else if( $(a).hasClass('opened') ) {
						
						$(n).removeClass('fa-minus').addClass('fa-plus');
						$(a).removeClass('opened').addClass('closed');
					
					}



				});
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
